
import { CampaignType } from 'src/@types/valueMatching/enums';

/** Set of valid CampaignType values for runtime validation */
const VALID_CAMPAIGN_TYPES = new Set<string>(Object.values(CampaignType));

/**
 * Validates that the given value is a valid CampaignType enum member.
 *
 * @param value - The value to validate
 * @returns True if the value is a valid CampaignType
 */
export function isValidCampaignType(value: string): value is CampaignType {
  return VALID_CAMPAIGN_TYPES.has(value);
}
